import React, { useCallback, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../hooks/hooks';
import { useForm } from 'react-hook-form';
import { Callout, Card, Flex, Spinner, Tabs, Text } from '@radix-ui/themes';
import TextFieldComponent from '../../components/inputs/Textfield/TextfieldComponent';
import { getStudentByCode } from '../../services/school/student/getStudentByCode';
import { getUserById } from '../../services/user/getUsers';
import { resetStudentData, setStudentData } from '../../redux/slices/school/student';
import { resetUserData, setUserData } from '../../redux/slices/users/user';
import { debounce, isEmpty, result, set } from 'lodash';
import { useMutation, useQuery } from 'react-query';
import { useGetPlanSubjectsQuery } from "../../hooks/useGetPlanSubjectsQuery"

import { UserPreview } from '../Users/UserPreview';
import { Lists } from '../../components/common/Lists';
import TableComponent from '../../components/common/Tables';
import { PlanSubjectType } from '../../types/PlanSubject';
import { ExclamationTriangleIcon, Pencil1Icon, TrashIcon } from '@radix-ui/react-icons';
import { useGetStudentGradeSubjectsQuery } from '../../hooks/useGetStudentGradeSubjectsQuery';
import { StudentSubjectGradeType } from '../../types/StudentSubjectGrade';
import { ConfirmAlertDialog } from '../../components/common/ConfirmAlertDialog';
import { number, object } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { APPROVED, REPROVED } from '../../utils/constants';
import { useGetCurrentAcademicYearQuery } from '../../hooks/useGetCurrentAcademicYearQuery';
import { createStudentSubjectGrade, updateStudentSubjectGrade } from '../../services/school/student/createStudent';
import toast from 'react-hot-toast';
import { useExportDocument } from '../../hooks/useExportDocument';
import { c } from 'framer-motion/dist/types.d-Cjd591yU';
import { resetLoaderAvailable, setLoaderAvailable } from '../../redux/slices/loaderController';
import { useLogoBase64 } from '../../hooks/useLogoBase64';
import { useIES } from '../../hooks/useIES';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { numberinFull } from '../../utils/codes';
type ActiveSegmentTab = 'course' | 'studentGrades' | 'subjects' | 'user';
const columnNamesMapPlanSubjects: { [key: string]: string } = {
  level: 'Ano',
  semester: 'Semestre',
  subject: 'Disciplina',
};
const columnNamesStudentGrades: { [key: string]: string } = {
  academicYear: 'Ano Acadêmico',
  level: 'Ano',
  semester: 'Semestre',
  subject: 'Disciplina',
  grade: 'Nota',
  result: 'Resultado  ',
};
export const formValidation = object({
  grade: number().typeError('Insira a nota em algarismos').min(0, "Min deve ser 0 (zero)").max(20, "Max. deve ser 20 (Vinte)").required("Por favor, preencha a nota."),
});
export const StudentGeneralGrades = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [activeSegment, setActiveSegment] = useState<ActiveSegmentTab>('user');
  const dispatch = useAppDispatch();
  const studentData = useAppSelector((state) => state.student.student);
  const userData = useAppSelector((state) => state.user);
  const [planSubject, setPlanSubject] = useState<PlanSubjectType | null>(null);
  const [studentSubjectGrade, setStudentSubjectGrade] = useState<StudentSubjectGradeType | null>(null);
  const { data: currentYear } = useGetCurrentAcademicYearQuery();
  const mutationCreateStudentSubjectGrade = useMutation({ mutationFn: createStudentSubjectGrade, mutationKey: "mutationCreateStudentSubjectGrade" })
  const mutationUpdateStudentSubjectGrade = useMutation({ mutationFn: updateStudentSubjectGrade, mutationKey: "mutationUpdateStudentSubjectGrade" })
  const loadingState = mutationCreateStudentSubjectGrade.isLoading;
  const { exportDocumentPdf: exportDocument, downloadOnly } = useExportDocument();
  const { logoBase64 } = useLogoBase64();
  const { IES } = useIES();
  const loginData = useSelector((state: RootState) => state.login.userData);

  const defaultValues = {
    studentCode: '',

  };

  const { control, handleSubmit, setValue, getValues, formState: { errors }, watch, reset } = useForm({
    defaultValues,
    mode: 'onBlur',
  });

  const { control: controlStudentSubjectGrade, handleSubmit: handleSubmitStudentSubjectGrade, setValue: setValueStudentSubjectGrade, getValues: getValuesStudentSubjectGrade, formState: { errors: errorsStudentSubjectGrade }, watch: watchStudentSubjectGrade, reset: resetStudentSubjectGrade } = useForm<{ grade: number }>({
    defaultValues: { grade: 0 },
    resolver: yupResolver(formValidation),
    mode: 'onBlur',
  });

  const { isLoading: isLoadingGetStudent, refetch: fetchStudentByCode, isError: isErrorGetStudent, error } = useQuery(
    ['getStudentByCode'],
    async () => {
      const studentCodeValue = getValues('studentCode');
      try {
        const studentData = await getStudentByCode(studentCodeValue);
        if (!studentData) return;
        const userData = await getUserById(studentData.idUser)
        if (!userData) return;

        dispatch(setStudentData(studentData));
        dispatch(setUserData(userData));
      } catch (error) {
        dispatch(resetStudentData());
        dispatch(resetUserData());
      }
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      retry: false
    }
  );

  const handleStudentCodeChange = useCallback(
    debounce((value: string) => {
      const trimmedValue = value.trim();
      setValue('studentCode', trimmedValue);
      if (trimmedValue.length >= 3) {
        fetchStudentByCode();
      } else {
        dispatch(resetStudentData());
        dispatch(resetUserData());
      }
    }, 300),
    [setValue, fetchStudentByCode]
  );
  const onSubmit = handleSubmit(async (data) => {

  })
  const { data: subjects, isLoading: loadingSubjects, refetch: refreshCourseSubjects } = useGetPlanSubjectsQuery({
    PageSize: 400,
    PageNumber: 1,
    // Level: level,
    // Semester: semester,
    IdCourse: studentData?.idCourse,
  }, {
    enabled: !!studentData?.idCourse,
  });

  const { data: studentGradeSubjects, refetch: refetchStudentGradeSubject } = useGetStudentGradeSubjectsQuery(
    { PageNumber: 1, PageSize: 400, IdStudent: studentData?.id },
    {
      enabled: !!studentData?.id,
      refetchOnWindowFocus: true,
      retry: false
    }
  );

  const confirmHandleEditOrCreate = async (planSubject: PlanSubjectType) => {
    try {
      const studentSubjectGrade: StudentSubjectGradeType = {
        idStudent: studentData?.id || '',
        idSubject: planSubject.idSubject || '',
        idAcademicYear: currentYear?.id || '',
        semester: planSubject.semester || 0,
        level: planSubject.level || 0,
        grade: getValuesStudentSubjectGrade('grade') || 0,
        result: getValuesStudentSubjectGrade('grade') >= 10 ? APPROVED : REPROVED,
      }
      await mutationCreateStudentSubjectGrade.mutateAsync(studentSubjectGrade);
      toast.success('Nota inserida');
      setPlanSubject(null);
      resetStudentSubjectGrade();
      refetchStudentGradeSubject();
      setActiveSegment('studentGrades');
    } catch (error) {
      toast.error(`Erro ao inserir nota: ${error instanceof Error ? error.message : 'Tente novamente'}`);
    }
  }

  const handleEditOrCreate = (planSubject: PlanSubjectType) => {
    setPlanSubject(planSubject);
  }

  const options = subjects?.items.map(() => [
    {
      label: 'Editar',
      onClick: (planSubject: PlanSubjectType) => handleEditOrCreate(planSubject),
      icon: <Pencil1Icon />
    },
  ]) || [];

  const openDeleteDialog = (studentSubjectGrade: StudentSubjectGradeType) => {
    setStudentSubjectGrade(studentSubjectGrade);
  }
  const confirmDeleteStudentSubjectGrade = async (studentSubjectGrade: StudentSubjectGradeType) => {
    try {
      await mutationUpdateStudentSubjectGrade.mutateAsync({
        ...studentSubjectGrade,
        status: false
      });
      toast.success('Nota excluída');
      setStudentSubjectGrade(null);
      refetchStudentGradeSubject();
    } catch (error) {
      toast.error(`Erro ao eliminar nota: ${error instanceof Error ? error.message : 'Tente novamente'}`);
    }
  }

  const optionsStudentGrades = studentGradeSubjects?.items.map(() => [
    {
      label: 'Eliminar',
      onClick: (studentSubjectGrade: StudentSubjectGradeType) => openDeleteDialog(studentSubjectGrade),
      icon: <TrashIcon />
    },
  ]) || [];
  const isEmptyWatchStudentSubjectGrade_grade =
    isEmpty(watchStudentSubjectGrade('grade')) || !!errorsStudentSubjectGrade.grade;

  const handlePrintStudentGrades = async () => {
    if (!studentData) {
      toast.error("Nenhum estudante seleccionado para imprimir as notas.");
      return;
    }
    const dataToPrint = studentGradeSubjects?.items ?? [];
    try {
      dispatch(setLoaderAvailable(true))
      const studentUser = await getUserById(studentData.idUser);
      const currentDate = new Date().toLocaleDateString("pt-PT");

      const data: any = {
        type: "STUDENT_GRADES",
        outputFormat: "DOCX",
        data: {
          nome_completo: loginData.Fullname,
          cargo: loginData?.Role,
          ies: IES.NAME,
          documento_de_identificacao: studentUser?.bi,
          curso: studentData?.course,
          estudante: studentData?.fullname,
          emitido: `${currentDate}`,
          local: IES.COUNTRY,
          mae: studentData?.mother,
          pai: studentData?.father,
          grades: dataToPrint.map((sub) => ({
            ano_lectivo_disciplina: `${sub.academicYear}`,
            nivel_semestre: `${sub.level}/${sub.semester}`,
            disciplina: sub.subject,
            resultado: `${sub.grade} (${numberinFull(sub.grade)} Valores)`,
          })),
        },
        logoBase64: logoBase64 ?? ""
      };
      await exportDocument(data, "STUDENT_GRADES");
      toast.success("Documento de notas exportado com sucesso!");
    } catch (error) {
      toast.error(`Erro ao gerar o documento: ${error instanceof Error ? error.message : 'Tente novamente'}`);
    } finally {
      dispatch(resetLoaderAvailable())
    }

  }
  return (
    <Card size='5'>
      <form onSubmit={onSubmit} noValidate>
        <Flex direction='column' gap='3'>

          <TextFieldComponent
            name="studentCode"
            label="Código do estudante"
            control={control}
            errors={errors}
            fieldProps={{
              placeholder: 'Digite o código do estudante',
              onChange: (e: React.ChangeEvent<HTMLInputElement>) => handleStudentCodeChange(e.target.value),
              onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => {
                e.preventDefault();
                const pastedText = e.clipboardData.getData('text');
                handleStudentCodeChange(pastedText);
              }
            }}
          />
          {isLoadingGetStudent ? <Spinner loading /> :
            isErrorGetStudent ? <Flex direction="column">
              <Callout.Root color="red" role="alert">
                <Callout.Icon>
                  <ExclamationTriangleIcon />
                </Callout.Icon>
                <Callout.Text>
                  Não foi possível localizar o estudante
                </Callout.Text>
              </Callout.Root>
            </Flex> : <Card size='5'>
              <Tabs.Root value={activeSegment} onValueChange={(tabToNavigate) => {
                setActiveSegment(tabToNavigate as ActiveSegmentTab)
              }}>
                <Tabs.List>
                  <Tabs.Trigger value={'user'} >
                    Dados gerais
                  </Tabs.Trigger>
                  <Tabs.Trigger value={'course'} >
                    Curso
                  </Tabs.Trigger>
                  <Tabs.Trigger value={'subjects'} >
                    Cadeiras
                  </Tabs.Trigger>
                  <Tabs.Trigger value={'studentGrades'} >
                    Resultados
                  </Tabs.Trigger>
                </Tabs.List>
                <Tabs.Content value="user">
                  <Flex direction='column' gap='4'>
                    <UserPreview />
                  </Flex>
                </Tabs.Content>
                <Tabs.Content value="course">
                  <Flex direction='column' gap='4'>
                    <Text weight="bold">Departamento:</Text>
                    {studentData?.departament ? (
                      <Text>{studentData?.departament}</Text>
                    ) : (
                      <Text color="gray">Nenhum departamento encontrado</Text>
                    )}

                    <Text weight="bold">Curso:</Text>
                    {studentData?.course ? (
                      <Text>{studentData?.course}</Text>
                    ) : (
                      <Text color="gray">Nenhum curso encontrado</Text>
                    )}
                  </Flex>
                </Tabs.Content>
                <Tabs.Content value="subjects">
                  <Lists
                    status={'success'}
                    TableComponent={() =>
                      <TableComponent
                        columns={Object.keys(columnNamesMapPlanSubjects)}
                        items={subjects?.items?.sort((a, b) => a.level - b.level).sort((a, b) => a.semester - b.semester) || []}
                        options={options}
                        columnNamesMap={columnNamesMapPlanSubjects}
                        totalPages={1}
                        currentPage={1}
                        onPageChange={() => { }}
                        enableExportToExcel={true}
                      //totalItems={subjects?.totalItems || 0}

                      />
                    }
                  />
                  <ConfirmAlertDialog
                    open={!!planSubject}
                    descriptionComponent={
                      <>
                        <Flex direction="column" gap="3">
                          <Text>Disciplina:  {planSubject?.subject}</Text>
                          <Text>Ano: {planSubject?.level}</Text>
                          <Text>Semestre: {planSubject?.semester}</Text>
                          {/* <Text>{planSubject?.hasExam ? "Exame" : "Sem Exame"}</Text> */}
                          <TextFieldComponent name="grade" label='Nota' control={controlStudentSubjectGrade} errors={errorsStudentSubjectGrade} fieldProps={{ placeholder: 'Nota' }} style={{ width: '100%' }} required={true} />
                          <Text>Resultado: {watchStudentSubjectGrade('grade') >= 10 ? APPROVED : REPROVED}</Text>
                        </Flex>
                      </>
                    }
                    onOpenChange={(open) => !open && setPlanSubject(null)}
                    title="Insira a nota do estudante"
                    confirmLabel="Guardar"
                    confirmColor="blue"
                    item={planSubject}
                    disabledConfirm={isEmptyWatchStudentSubjectGrade_grade}
                    onConfirm={confirmHandleEditOrCreate}
                    onCancel={() => setPlanSubject(null)}
                  />
                </Tabs.Content>
                <Tabs.Content value="studentGrades">
                  <Lists
                    handleClickCreate={handlePrintStudentGrades}
                    handleClickCreateText='Imprimir Notas do Estudante'
                    status={'success'}
                    TableComponent={() =>
                      <TableComponent
                        columns={Object.keys(columnNamesStudentGrades)}
                        items={studentGradeSubjects?.items?.sort((a, b) => a.level - b.level).sort((a, b) => a.semester - b.semester) || []}
                        options={optionsStudentGrades}
                        columnNamesMap={columnNamesStudentGrades}
                        totalPages={1}
                        currentPage={1}
                        //  totalItems={studentGradeSubjects?.totalItems || 0}
                        onPageChange={() => { }}
                      />
                    }
                  />
                  <ConfirmAlertDialog
                    open={!!studentSubjectGrade}
                    descriptionComponent={
                      <>
                        <Flex direction="column" gap="3">
                          <Text>Disciplina:  {studentSubjectGrade?.subject}</Text>
                          <Text>Ano: {studentSubjectGrade?.level}</Text>
                          <Text>Semestre: {studentSubjectGrade?.semester}</Text>
                          <Text>Nota: {studentSubjectGrade?.grade}</Text>
                          <Text>Resultado: {studentSubjectGrade?.result}</Text>
                        </Flex>
                      </>
                    }
                    onOpenChange={(open) => !open && setStudentSubjectGrade(null)}
                    title="Confirma a eliminação da nota do estudante?"
                    confirmLabel="Eliminar"
                    confirmColor="red"
                    item={studentSubjectGrade}
                    onConfirm={confirmDeleteStudentSubjectGrade}
                    onCancel={() => setStudentSubjectGrade(null)}
                  />
                </Tabs.Content>
              </Tabs.Root>
            </Card>}
        </Flex>
      </form>
    </Card>
  )
}

